<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/184t8AS/tc-custom/9781467460064.jpg?1737194763255" alt="This image is the cover for the book A Theology for the Twenty-First Century"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Theology for the Twenty-First Century
      </h1>
      <p class="bookDescription body article font2">
        <p>Christianity in the United States is in crisis. Liberalism is declining, evangelicalism is splintering, increasing numbers of Christians are slipping away from churches, and more and more young people are for various reasons finding Christianity as they conceive it (a metaphysical thought system, or society of science-deniers, or an ideology for oppressors) not just implausible but repellent. At the same time, Christians across denominational and ideological divides are rediscovering a moral core, especially in the Jesus of the Gospels, that reactivates and unites them, and this kind of faith appeals to many who consider themselves averse to all traditional organized religion. But any revitalized Christian faith is going to need to understand its rootedness in, and interpretation of, Christianity’s foundational texts and traditions. </p><p>Noted theologian Douglas F. Ottati steps in to offer a theology for this new era. Combining deep learning in texts and traditions with astute awareness of contemporary questions and patterns of thought and life, he asks: what does it mean, in our time, to understand the God of the Bible as Creator and Redeemer? Distilling the content of Christian faith into seventy concise propositions, he explains each in lucid, cogent prose. <i>A Theology for the Twenty-First Century</i> will be an essential textbook for those training for ministry in our current climate, a wise guide for contemporary believers who wonder how best to understand and communicate their faith, and an inviting and intelligent resource for serious inquirers who wonder whether the way of Jesus might help them grasp the real world while remaining open to the transcendent.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Douglas F. Ottati
      </h2>
      
      <p class="authorDescription body article">&#160;<B>Douglas F. Ottati</B>&#160;is the Craig Family Distinguished Professor of Reformed Theology and Justice at Davidson College in North Carolina. He taught for many years at what is now Union Presbyterian Seminary in Richmond, Virginia, and is a past president of the Society of Christian Ethics. He is also a ruling elder in the Presbyterian Church (USA). Among his other books are&#160;<I>A Theology for the Twenty-First Century</I>&#160;and&#160;<I>Hopeful Realism: Reclaiming the Poetry of Theology.</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?26df299b